import axios from "axios";

export const getAllUserInfo = (): any => {
  return axios.get("/user/v1/all");
};
